import type { NodeDefinition } from "~/nodes/types";

export const numberNode: NodeDefinition = {
  type: "number",
  label: "Number",
  category: "Math",
  inputs: [],
  outputs: [{ key: "num", label: "Number", socket: "number" }],
  controls: [{ kind: "number", key: "num", label: "num" }],
  defaults: { num: 1 },

  compute(ctx) {
    return { num: ctx.number("num", 1) };
  },
};
